module.exports = __webpack_public_path__ + "static/media/HCMM104.50a5d51c.jpg";